function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M2.75 2h18.5M5.38 4h1.5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeDasharray: "3.42 1.14",
  d: "M8.01 4h8.55"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M17.13 4h1.5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 17V5h11v12z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgComponent;